import { isAxiosError } from "axios"

/** Reprises d'une lecture, comme le défaut de React Query. */
const MAX_QUERY_RETRIES = 3

/** Bornes des codes HTTP d'erreur client. */
const FIRST_CLIENT_ERROR = 400
const LAST_CLIENT_ERROR = 499

/** Refus passagers : délai dépassé, trop de requêtes. */
const TRANSIENT_CLIENT_ERRORS = [408, 429]

/**
 * Une erreur 4xx se rejoue à l'identique.
 * La ressource est absente ou refusée.
 * Réseau coupé, 408, 429 et 5xx se retentent, trois fois au plus.
 *
 * @example
 * shouldRetryQuery(0, networkError) // true
 * shouldRetryQuery(0, notFoundError) // false
 */
export function shouldRetryQuery(failureCount: number, error: unknown): boolean {
  if (failureCount >= MAX_QUERY_RETRIES) return false
  if (!isAxiosError(error)) return true
  const status = error.response === undefined ? 0 : error.response.status
  if (TRANSIENT_CLIENT_ERRORS.includes(status)) return true
  return status < FIRST_CLIENT_ERROR || status > LAST_CLIENT_ERROR
}
